// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1gqYJ","upload":"Small_upload__y05mH","imageWrap":"Small_imageWrap__2nYlk","removeBtn":"Small_removeBtn__sWrgV"};